import React, { useContext, useMemo, useState } from "react";

import { css } from "@emotion/react";

import { DiscountMessageBoxContext } from "../context";

import { CloseButton } from "./CloseButton";

interface DiscountMessageBoxProps {
  dontRenderCloseButton?: boolean;
}
export const DiscountMessageBox = ({
  dontRenderCloseButton,
}: DiscountMessageBoxProps) => {
  const {
    idForHiding,
    updateIgVars,
    getWidgetConfig,
    isMobile,
    isFe,
    theme,
    isHidden: initIsHidden,
  } = useContext(DiscountMessageBoxContext);

  const [isVisible, setIsVisible] = useState<boolean>(!initIsHidden || true);

  const containerCss = useMemo(
    () => css`
      @media only screen and (max-width: 600px) {
        display: ${isFe
          ? "block"
          : isVisible
            ? theme.container.display
            : "none"};
        z-index: ${theme.container.zIndex};
        background-color: ${theme.container.backgroundColor};
        color: ${theme.container.textColor};
        border-top-right-radius: ${theme.container.borderTopRightRadius};
        border-bottom-right-radius: ${theme.container.borderBottomRightRadius};
        border-bottom-left-radius: ${theme.container.borderBottomLeftRadius};
        border-top-left-radius: ${theme.container.borderTopLeftRadius};
        top: ${isFe ? "unset" : theme.container.top};
        left: ${isFe ? "unset" : theme.container.left};
        box-shadow: ${theme.container.boxShadow};
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box; /* Opera/IE 8+ */
        -webkit-font-smoothing: antialiased;
      }
      -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
      -moz-box-sizing: border-box; /* Firefox, other Gecko */
      box-sizing: border-box; /* Opera/IE 8+ */
      -webkit-font-smoothing: antialiased;
      display: ${isFe ? "block" : isVisible ? theme.container.display : "none"};
      z-index: ${theme.container.zIndex};
      background-color: ${theme.container.backgroundColor};
      color: ${theme.container.textColor};
      border-top-right-radius: ${theme.container.borderTopRightRadius};
      border-bottom-right-radius: ${theme.container.borderBottomRightRadius};
      border-bottom-left-radius: ${theme.container.borderBottomLeftRadius};
      border-top-left-radius: ${theme.container.borderTopLeftRadius};
      top: ${isFe ? "unset" : theme.container.top};
      left: ${isFe ? "unset" : theme.container.left};

      box-shadow: ${theme.container.boxShadow};
      position: ${isFe ? "unset" : "absolute"};
      justify-content: start;
      flex-direction: column;
      width: 350px;
      padding: 18px 30px 10px 20px;
      min-height: ${theme.container.height};
    `,
    [theme, isMobile, isVisible]
  );

  const titleCss = useMemo(
    () => css`
      font-size: ${theme.container.titleFontSize};
      line-height: 1.5;
      font-weight: ${theme.container.titleFontWeight};
      text-align: start;
    `,
    [theme, isMobile, isVisible]
  );

  const bodyCss = useMemo(
    () => css`
      font-size: ${theme.container.bodyFontSize};
      line-height: 1.5;
      font-weight: ${theme.container.bodyFontWeight};
      text-align: start;
    `,
    [theme, isMobile, isVisible]
  );

  const handeCancelClick = () => {
    setIsVisible(false);
    if (updateIgVars) {
      updateIgVars(`${idForHiding}-ig-mb-hide`, "true");
    }
  };

  const title = getWidgetConfig("variables.textReplacements.title");
  const body = getWidgetConfig("variables.textReplacements.body");

  return (
    <div css={containerCss} className={"ig-message-box-container"}>
      {!dontRenderCloseButton && (
        <CloseButton setIsVisible={handeCancelClick} />
      )}
      <div css={titleCss} className={"ig-message-box-title"}>
        {title ? title : isFe ? "PROMO TITLE HERE!" : ""}
      </div>
      <div css={bodyCss} className={"ig-message-box-body"}>
        {body
          ? body
          : isFe
            ? "Sit amet, consectetur adipiscin elit, sed do eiusmod tempor. Ut enim ad minim."
            : ""}
      </div>
    </div>
  );
};
